export enum SearchTabAlias {
    CONTENT_SEARCH = "contentSearchTab",
    DIRECTORY_SEARCH = "directorySearchTab",
    MARKETPLACE_SEARCH = "marketplaceSearchTab"
}
